import type { IKemState } from "./reducer";
import KemActionTypes from "./types";

export const updateAppKemState = (payload: IKemState) => ({
  type: KemActionTypes.UPDATE_APP_KEM_STATE,
  payload,
});

export const logoutKem = () => ({
  type: KemActionTypes.LOGOUT,
  payload: {} as Partial<IKemState>,
});
